import React from "react";
import PropTypes from "prop-types";
import { AlertMsgStyles } from "../styles/";
import { withStyles } from "@material-ui/core";

const AlertMsg = (props) => {
  const { message, classes } = props;
  return <div className={classes.root}>{message}</div>;
};

AlertMsg.propTypes = {
  message: PropTypes.string,
  classes: PropTypes.object,
};

export default withStyles(AlertMsgStyles)(AlertMsg);
